<app-header></app-header>

<div class="page-title-area page-title-style-two item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Acasa</a></li>
                <li>Pentru pacienti</li>
            </ul>
            <h2>Informatii despre accesarea serviciilor clinicii</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12">
                <h3>Accesul la medicul de familie</h3>

                <ol>
                    <li>Cererea de asigurat completata in 4 exemplare
                        – se gaseste jos la serviciul de registratura si trebuie semnata la serviciul
                        de contabilitate al locului de munca/talonul de pensie</li>
                    <li>Cu aceste documente trebuie mers la CASA OPSNAJ din Strada Popa Savu nr.
                        45 , unde se va inregistra oficial aceasta cerere</li>
                    <li>Reveniti in institutia noastra, cu buletinul, cardul de sanatate si
                        cererea cu stampila casei OPSNAJ, la serviciul registratura unde veti fi
                        introdus in baza de date si va puteti alege unul din medicii nostri de familie</li>
                    <li>Imediat dupa ce ati fost introdus in baza de date va puteti programa
                        la medicul de familie ales.</li>
                </ol>

                <h3>Accesul la medicii specialisti</h3>
                <ol>
                    <li>Pacientii cu medic de familie in CMDTAMP
                        <p>
                            Se face pe baza unui bilet de trimitere de la medicul de familie sau alt
                            specialist de la noi din clinica
                        </p>
                    </li>
                    <li>
                        Pacientii cu medic de familie in afara CMDTAMP
                        <p>
                            Pe baza unui bilet de trimitere de la medicul de familie curant/alt medic specialist
                        </p>
                        <p>
                            Pentru programare trebuie sa va prezentati la serviciul programari unde sunteti introdus in
                            baza de
                            date ca si pacient
                        </p>
                    </li>
                </ol>

                <h3>Spitalizarea de ZI</h3>
                <ol>
                    <li> Se face pe baza unui bilet de trimitere in urma caruia medicul specialist din incinta
                        policlinicii decide daca este cazul de spitalizare de zi sau nu, urmand sa reveniti atunci
                        cand va spune acesta pentru internare </li>
                    <li>
                        Unele servicii pot fi contracost</li>
                </ol>
                <p>
                    <img src="/image/image_gallery?uuid=79eefde3-f24d-44cb-8813-28fa335b0081&amp;groupId=10205&amp;t=1604487715445"
                        alt="" width="784" height="752">

                </p>
            </div>
        </div>
    </div>
</div>